import { Reveal } from "../components/Reveal";
import { SectionHead } from "../components/SectionHead";

export const ProductLines = ({ t, label }) => (
  <section id="lines" data-testid="section-lines" className="py-32 md:py-48 border-b border-[#272A2E]">
    <div className="max-w-[1600px] mx-auto px-6 md:px-10">
      <Reveal><SectionHead index={t.index} title={t.title} lead={t.lead} /></Reveal>
      <div className="space-y-6 md:space-y-10">
        {t.items.map((item, i) => (
          <Reveal key={item.tag} delay={0.05}>
            <article data-testid={`product-line-${i + 1}`}
              className={`grid grid-cols-12 gap-6 md:gap-10 items-center group ${i % 2 === 1 ? "" : ""}`}>
              <div className={`col-span-12 lg:col-span-7 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
                <div className="relative overflow-hidden" style={{ clipPath: "polygon(0 0, calc(100% - 40px) 0, 100% 40px, 100% 100%, 0 100%)" }}>
                  <span className="absolute top-4 left-4 z-10 text-xs font-mono tracking-[0.2em] uppercase bg-[#FF2A00] text-black px-3 py-1">{item.tag}</span>
                  <img src={item.img} alt={item.t} data-testid={`product-line-image-${i + 1}`}
                    className="w-full aspect-[16/9] object-cover grayscale opacity-60 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-[1.03] transition-[filter,opacity,transform] duration-700" />
                </div>
              </div>
              <div className={`col-span-12 lg:col-span-5 ${i % 2 === 1 ? "lg:order-1" : ""}`}>
                <p className="text-xs font-mono tracking-[0.2em] text-[#FF2A00] uppercase mb-4">[ {item.tag} ]</p>
                <h3 className="font-display text-2xl md:text-3xl font-bold uppercase tracking-tight text-white leading-tight">{item.t}</h3>
                <ul className="mt-8 space-y-4">
                  {item.specs.map((s, j) => (
                    <li key={j} className="flex gap-4 text-sm font-mono tracking-tight text-[#8A8F98] leading-relaxed">
                      <span className="text-[#FF2A00] shrink-0">+</span>{s}
                    </li>
                  ))}
                </ul>
                <a href={`/linea/${i + 1}`} data-testid={`product-line-link-${i + 1}`}
                  className="inline-block mt-8 text-xs font-mono tracking-[0.2em] uppercase text-[#FF2A00] border-b border-[#FF2A00] pb-1 hover:text-white hover:border-white transition-colors duration-300">
                  {label} →
                </a>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
